import ObservationSection from './ObservationSection';

export default ObservationSection;
